import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { tap ,map,finalize} from "rxjs/operators";
import { SiteMenuService } from "src/app/site-menu/site-menu/common/services/site-menu.service";
import { listForm } from "./ecommerce-module";
import { Categories } from "src/app/views/site-categories/categories";


@Injectable({
  providedIn: "root",
})
export class CategoryService {
  categorySubject = new BehaviorSubject<any>(null);
  category$: Observable<any> = this.categorySubject.asObservable();

  constructor(private httpClient: HttpClient, private siteMenuService: SiteMenuService) {}

  getAllCategories(filter?:listForm) {
    return this.httpClient
      .post("/CategoriesApi/GetAllCategories", {
        pagination:{
          pageSize: filter.pageSize ? filter.pageSize : 5,
          pageNumber: filter.pageNumber ? filter.pageNumber : 0,
        },
        eCategoryTypes:filter.eCategoryTypes ? filter.eCategoryTypes : 2,
        searchText: filter.searchText ? filter.searchText : "",
      })
      .pipe(
        tap((res) => {
          this.categorySubject.next(res);
        })
      );
  }
  getRelatedCategory(id:number){
    return this.httpClient.get(`/Categories/GetCategoriesByCultureParentId/${id}`).pipe(
        map((res:any) => res)
    );
  }

// --
getCategoryById(id:number) { 
  return this.httpClient.get(`/CategoriesApi/GetCategoriesById/${id}`).pipe(
    map((res:any) => res)
);
}

getCategoriesList() { 
  return this.httpClient.get(`/CategoriesApi/GetCategories`)
}

addNewCategory(data) { 
  return this.httpClient.post(`/CategoriesApi/AddCategory` , data)
}

updateCategory(data:Categories) { 
  return this.httpClient.post(`/CategoriesApi/UpdateCategory` , data)
}

changeCategoryStatus(categoryId , status) {
  return this.httpClient.get(`/CategoriesApi/ChangeStatus/${categoryId}/${status}`)
}
// 
  saveCategoryMenu(menus) {
    return this.httpClient.post('/Menus/AddEditMenuForCategories', menus).pipe(
        finalize(() =>  this.siteMenuService.updateMenus())
    );
}
getMenuByCategoryCultureParentId(parentId: number): Observable<any> {
    return this.httpClient.get<any>(`/Menus/getMenuByCategoryCultureParentId/${parentId}`);
}




// to not change the behaver of existing  API's call  

getCategoriesById(id:number) :Observable<Categories>{
  return this.httpClient.get<Categories>(`/CategoriesApi/GetCategoriesById/${id}`)

}



}
